import React from 'react';
import Modal from 'react-bootstrap/esm/Modal';
import { ConfirmModalType } from '../../utils/growth-wheel-utils';

interface ConfirmationModalProps {
    icon: React.ReactNode;
    show: boolean;
    title: string;
    description: string;
    modalType: ConfirmModalType;
    onConfirm: () => void;
    onCancel: () => void;
}

export const ConfirmationModal = ({ icon, show, title, description, modalType, onConfirm, onCancel }: ConfirmationModalProps) => {
    return (
        <Modal show={show} onHide={onCancel} centered>
            <div className="gw-confirmation-modal">
                <div className="gw-confirmation-icon-container">
                    <div className="gw-confirmation-icon">
                        {icon}
                    </div>
                </div>
                <h3 className="gw-confirmation-title">{title}</h3>
                <p className="gw-confirmation-description">{description}</p>

                <div className="gw-confirmation-buttons">
                    {modalType !== ConfirmModalType.ALERT && <>
                        <button onClick={onCancel} className="gw-confirmation-button-cancel">Cancel</button>
                        <button onClick={onConfirm} className="gw-btn-submit">{modalType === ConfirmModalType.FOCUS ? 'Mark as Focus' : 'Remove'}</button>
                    </>}
                    {modalType === ConfirmModalType.ALERT && <button onClick={onCancel} className="gw-btn-submit">OK</button>}
                </div>
            </div>
        </Modal>
    );
};